import { Link } from 'react-router-dom';
import { Instagram, Facebook } from 'lucide-react';

// NF Construction Logo - New transparent version
const LOGO_URL = "https://customer-assets.emergentagent.com/job_mangawhai-126/artifacts/lmyojf3d_NF%20Construction%202025%20copy.png";
const NF_WEBSITE = "https://www.nfconstruction.co.nz";
const INSTAGRAM_URL = "https://www.instagram.com/nfconstruction_/";
const FACEBOOK_URL = "https://www.facebook.com/NFConstructionNZ/";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#1a1e1a] border-t border-white/5">
      <div className="max-w-6xl mx-auto px-6 md:px-12 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Logo */}
          <div>
            <img 
              src={LOGO_URL} 
              alt="NF Construction" 
              className="h-12 w-auto"
              style={{ 
                filter: 'invert(1) brightness(1.5)',
              }}
            />
          </div>

          {/* Links */}
          <div className="space-y-4">
            <Link to="/" className="block text-white/50 text-sm hover:text-white transition-colors">
              The 126 House
            </Link>
            <Link to="/about" className="block text-white/50 text-sm hover:text-white transition-colors">
              NF Construction
            </Link>
            <a href={NF_WEBSITE} target="_blank" rel="noopener noreferrer" className="block text-white/50 text-sm hover:text-white transition-colors">
              nfconstruction.co.nz
            </a>
            <Link to="/privacy" className="block text-white/50 text-sm hover:text-white transition-colors" data-testid="footer-privacy-link">
              Privacy notice
            </Link>
          </div>

          {/* Social */}
          <div className="flex space-x-4">
            <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="text-white/40 hover:text-white transition-colors">
              <Instagram size={18} />
            </a>
            <a href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer" className="text-white/40 hover:text-white transition-colors">
              <Facebook size={18} />
            </a>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/5 space-y-4">
          <p className="text-white/30 text-xs leading-relaxed max-w-4xl" data-testid="footer-legal">
            The information on this website has been prepared by NF Construction for marketing purposes only
            and does not form part of any offer or contract. Renders, images and floor plans are indicative and
            may differ from the completed home. Prices are in New Zealand dollars, subject to contract and may
            change without notice. Nothing on this website is legal, financial, tax or immigration advice, and no
            representation is made that any purchaser will obtain a visa or Overseas Investment Office consent.
            Purchasers should make their own enquiries and obtain independent professional advice. Marketed in
            conjunction with Bayleys Real Estate Ltd, Licensed under the REAA 2008.
          </p>
          <p className="text-white/30 text-xs">
            © {currentYear} NF Construction. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
